module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-chalk-1-dc50d6e2ce45ce13657ab12ad09cf716.png";